const NON_DOM_PROPS = new Set([
  'allowedValues',
  'changed',
  'changedMap',
  'error',
  'errorMessage',
  'field',
  'fieldType',
  'fields',
  'initialCount',
  'label',
  'name',
  'onChange',
  'readOnly',
  'showInlineError',
  'transform',
  'value',
  'required',
  'disabled',
  'oneOf',
  'anyOf',
  'enum',
  'type',
  'description',
  'ui-params',
  'items',
  'options',
  'minCount',
  'maxCount',
  'placeholder',
  'warning',
  'exists',
  'min',
  'max',
  'step',
])

export function filterDOMProps(props: Record<string, any>): Record<string, any> {
  const filtered: Record<string, any> = {}
  for (const [key, val] of Object.entries(props)) {
    if (!NON_DOM_PROPS.has(key)) {
      filtered[key] = val
    }
  }
  return filtered
}
